if (typeof window.jQuery !== "undefined") {

!function($){

var defaults = {
  url: false,
  callback: false,
  target: false,
  duration: 120,
  touch: true,
  onZoomIn: false,
  onZoomOut: false,
  magnify: 1
};

$.zoom = function(container, target, img, scale) {
  var width, height, xRatio, yRatio, offset,
      $container = $(container),
      position = $container.css("position"),
      $target = $(target);

  container.style.position = /(absolute|fixed)/.test(position) ? position : "relative";
  container.style.overflow = "hidden";

  img.style.width = img.style.height = "";

  $(img)
    .addClass("zoomImg")
    .css({
      position: "absolute",
      top: 0,
      left: 0,
      opacity: 0,
      width: img.width * scale,
      height: img.height * scale,
      border: "none",
      maxWidth: "none",
      maxHeight: "none"
    })
    .appendTo(container);

  return {
    init: function() {
      width = $container.outerWidth();
      height = $container.outerHeight();

      var targetWidth = target === container ? width : $target.outerWidth();
      var targetHeight = target === container ? height : $target.outerHeight();

      xRatio = (img.width - width) / targetWidth;
      yRatio = (img.height - height) / targetHeight;

      offset = $target.offset();
    },

    move: function(e) {
      var x = e.pageX - offset.left;
      var y = e.pageY - offset.top;

      x = Math.max(Math.min(x, width), 0);
      y = Math.max(Math.min(y, height), 0);

      img.style.left = -(x * xRatio) + "px";
      img.style.top = -(y * yRatio) + "px";
    }
  };
};

$.fn.zoom = function(options) {

  return this.each(function() {

    var settings = $.extend({}, defaults, options || {});
    var target = settings.target && $(settings.target)[0] || this;
    var container = this;
    var $container = $(container);

    var img = document.createElement("img");
    var $img = $(img);

    if (!settings.url) {
      var image = container.querySelector("img");
      if (image) {
        settings.url = image.getAttribute("data-src") || image.currentSrc || image.src;
      }
      if (!settings.url) return;
    }

    $container.one("zoom.destroy", function() {
      $container.off(".zoom");
      img.onload = null;
      $img.remove();
    });

    img.onload = function() {
      var zoom = $.zoom(target, container, img, settings.magnify);

      zoom.init();

      $container
        .on("mouseenter.zoom", function(e) {
          zoom.init();
          zoom.move(e);

          $img.stop().fadeTo(settings.duration, 1,
            $.isFunction(settings.onZoomIn) && settings.onZoomIn.call(img)
          );
        })
        .on("mouseleave.zoom", function() {
          $img.stop().fadeTo(settings.duration, 0,
            $.isFunction(settings.onZoomOut) && settings.onZoomOut.call(img)
          );
        })
        .on("mousemove.zoom", zoom.move);

      if ($.isFunction(settings.callback)) {
        settings.callback.call(img);
      }
    };

    img.setAttribute("role", "presentation");
    img.alt = "";
    img.src = settings.url;

  });

};

$.fn.zoom.defaults = defaults;

}(window.jQuery);

} else {
  console.warn("image.zoom.js skipped because jQuery is not loaded.");
}